import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'money',
})
export class MoneyPipe implements PipeTransform {
    constructor() {}

    transform(n:any, c:number = 2, d:string = ',', t:string = '.'){
        let s:string = n < 0 ? "-" : "";
        let i:any = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "";
        let j:number = (i.length) > 3 ? i.length % 3 : 0;
        return s + 'R$ ' + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    }
}



// WEBPACK FOOTER //
// ./src/pipes/money/money.ts